export const MetroAreas = [
  {
    regionId: "394388",
    name: "Birmingham, AL",
    city: "Birmingham",
    state: "Alabama",
  },
  {
    regionId: "394798",
    name: "Little Rock, AR",
    city: "Little Rock",
    state: "Arkansas",
  },
  {
    regionId: "394976",
    name: "Phoenix, AZ",
    city: "Phoenix",
    state: "Arizona",
  },
  { regionId: "395167", name: "Tucson, AZ", city: "Tucson", state: "Arizona" },
  {
    regionId: "394357",
    name: "Bakersfield, CA",
    city: "Bakersfield",
    state: "California",
  },
  {
    regionId: "394619",
    name: "Fresno, CA",
    city: "Fresno",
    state: "California",
  },
  {
    regionId: "753899",
    name: "Los Angeles-Long Beach-Anaheim, CA",
    city: "Los Angeles-Long Beach-Anaheim",
    state: "California",
  },
  {
    regionId: "395025",
    name: "Riverside, CA",
    city: "Riverside",
    state: "California",
  },
  {
    regionId: "395045",
    name: "Sacramento, CA",
    city: "Sacramento",
    state: "California",
  },
  {
    regionId: "395056",
    name: "San Diego, CA",
    city: "San Diego",
    state: "California",
  },
  {
    regionId: "395057",
    name: "San Francisco, CA",
    city: "San Francisco",
    state: "California",
  },
  {
    regionId: "395059",
    name: "San Jose, CA",
    city: "San Jose",
    state: "California",
  },
  {
    regionId: "394952",
    name: "Ventura, CA",
    city: "Ventura",
    state: "California",
  },
  {
    regionId: "394484",
    name: "Colorado Springs, CO",
    city: "Colorado Springs",
    state: "Colorado",
  },
  { regionId: "394530", name: "Denver, CO", city: "Denver", state: "Colorado" },
  {
    regionId: "394602",
    name: "Fort Collins, CO",
    city: "Fort Collins",
    state: "Colorado",
  },
  {
    regionId: "394669",
    name: "Hartford, CT",
    city: "Hartford",
    state: "Connecticut",
  },
  {
    regionId: "394908",
    name: "New Haven, CT",
    city: "New Haven",
    state: "Connecticut",
  },
  {
    regionId: "394415",
    name: "Stamford, CT",
    city: "Stamford",
    state: "Connecticut",
  },
  {
    regionId: "395209",
    name: "Washington, DC",
    city: "Washington",
    state: "Washington, DC",
  },
  {
    regionId: "394528",
    name: "Daytona Beach, FL",
    city: "Daytona Beach",
    state: "Florida",
  },
  {
    regionId: "394714",
    name: "Jacksonville, FL",
    city: "Jacksonville",
    state: "Florida",
  },
  {
    regionId: "394856",
    name: "Miami-Fort Lauderdale, FL",
    city: "Miami-Fort Lauderdale",
    state: "Florida",
  },
  { regionId: "395148", name: "Tampa, FL", city: "Tampa", state: "Florida" },
  {
    regionId: "394347",
    name: "Atlanta, GA",
    city: "Atlanta",
    state: "Georgia",
  },
  {
    regionId: "753924",
    name: "Urban Honolulu, HI",
    city: "Urban Honolulu",
    state: "Hawaii",
  },
  {
    regionId: "394531",
    name: "Des Moines, IA",
    city: "Des Moines",
    state: "Iowa",
  },
  {
    regionId: "394399",
    name: "Boise City, ID",
    city: "Boise City",
    state: "Idaho",
  },
  {
    regionId: "394463",
    name: "Chicago, IL",
    city: "Chicago",
    state: "Illinois",
  },
  {
    regionId: "394705",
    name: "Indianapolis, IN",
    city: "Indianapolis",
    state: "Indianna",
  },
  {
    regionId: "394807",
    name: "Louisville-Jefferson County, KY",
    city: "Louisville-Jefferson County",
    state: "Kentucky",
  },
  {
    regionId: "394367",
    name: "Baton Rouge, LA",
    city: "Baton Rouge",
    state: "Louisiana",
  },
  {
    regionId: "394404",
    name: "Boston, MA",
    city: "Boston",
    state: "Massachusetts",
  },
  {
    regionId: "395115",
    name: "Springfield, MA",
    city: "Springfield",
    state: "Massachusetts",
  },
  {
    regionId: "395238",
    name: "Worcester, MA",
    city: "Worcester",
    state: "Massachusetts",
  },
  {
    regionId: "394358",
    name: "Baltimore, MD",
    city: "Baltimore",
    state: "Maryland",
  },
  {
    regionId: "394532",
    name: "Detroit, MI",
    city: "Detroit",
    state: "Michigan",
  },
  {
    regionId: "394640",
    name: "Grand Rapids, MI",
    city: "Grand Rapids",
    state: "Michigan",
  },
  {
    regionId: "394865",
    name: "Minneapolis-St Paul, MN",
    city: "Minneapolis-St Paul",
    state: "Michigan",
  },
  {
    regionId: "394735",
    name: "Kansas City, MO",
    city: "Kansas City",
    state: "Missouri",
  },
  {
    regionId: "395121",
    name: "St. Louis, MO",
    city: "St. Louis",
    state: "Missouri",
  },
  {
    regionId: "394458",
    name: "Charlotte, NC",
    city: "Charlotte",
    state: "Missouri",
  },
  {
    regionId: "394549",
    name: "Durham, NC",
    city: "Durham",
    state: "North Carolina",
  },
  {
    regionId: "395012",
    name: "Raleigh, NC",
    city: "Raleigh",
    state: "North Carolina",
  },
  { regionId: "394938", name: "Omaha, NE", city: "Omaha", state: "Nebraska" },
  {
    regionId: "394312",
    name: "Albuquerque, NM",
    city: "Albuquerque",
    state: "New Mexico",
  },
  {
    regionId: "394775",
    name: "Las Vegas, NV",
    city: "Las Vegas",
    state: "Nevada",
  },
  {
    regionId: "394425",
    name: "Buffalo, NY",
    city: "Buffalo",
    state: "New York",
  },
  {
    regionId: "394913",
    name: "New York, NY",
    city: "New York",
    state: "New York",
  },
  {
    regionId: "395031",
    name: "Rochester, NY",
    city: "Rochester",
    state: "New York",
  },
  {
    regionId: "395143",
    name: "Syracuse, NY",
    city: "Syracuse",
    state: "New York",
  },
  { regionId: "394304", name: "Akron, OH", city: "Akron", state: "Ohio" },
  {
    regionId: "394466",
    name: "Cincinnati, OH",
    city: "Cincinnati",
    state: "Ohio",
  },
  {
    regionId: "394475",
    name: "Cleveland, OH",
    city: "Cleveland",
    state: "Ohio",
  },
  { regionId: "394492", name: "Columbus, OH", city: "Columbus", state: "Ohio" },
  { regionId: "394521", name: "Dayton, OH", city: "Dayton", state: "Ohio" },
  { regionId: "395160", name: "Toledo, OH", city: "Toledo", state: "Ohio" },
  {
    regionId: "394935",
    name: "Oklahoma City, OK",
    city: "Oklahoma City",
    state: "Oklahoma",
  },
  { regionId: "395169", name: "Tulsa, OK", city: "Tulsa", state: "Oklahoma" },
  {
    regionId: "394998",
    name: "Portland, OR",
    city: "Portland",
    state: "Oregon",
  },
  {
    regionId: "394318",
    name: "Allentown, PA",
    city: "Allentown",
    state: "Pennsylvania",
  },
  {
    regionId: "394974",
    name: "Philadelphia, PA",
    city: "Philadelphia",
    state: "Pennsylvania",
  },
  {
    regionId: "394982",
    name: "Pittsburgh, PA",
    city: "Pittsburgh",
    state: "Pennsylvania",
  },
  {
    regionId: "395005",
    name: "Providence, RI",
    city: "Providence",
    state: "Rhode Island",
  },
  {
    regionId: "394486",
    name: "Columbia, SC",
    city: "Columbia",
    state: "South Carolina",
  },
  {
    regionId: "394653",
    name: "Greenville, SC",
    city: "Greenville",
    state: "South Carolina",
  },
  {
    regionId: "394753",
    name: "Knoxville, TN",
    city: "Knoxville",
    state: "Tennessee",
  },
  {
    regionId: "394849",
    name: "Memphis, TN",
    city: "Memphis",
    state: "Tennessee",
  },
  {
    regionId: "394902",
    name: "Nashville, TN",
    city: "Nashville",
    state: "Tennessee",
  },
  { regionId: "394355", name: "Austin, TX", city: "Austin", state: "Texas" },
  {
    regionId: "394514",
    name: "Dallas-Fort Worth, TX",
    city: "Dallas-Fort Worth",
    state: "Texas",
  },
  { regionId: "394561", name: "El Paso, TX", city: "El Paso", state: "Texas" },
  { regionId: "394692", name: "Houston, TX", city: "Houston", state: "Texas" },
  {
    regionId: "395055",
    name: "San Antonio, TX",
    city: "San Antonio",
    state: "Texas",
  },
  { regionId: "394931", name: "Ogden, UT", city: "Ogden", state: "Utah" },
  { regionId: "395006", name: "Provo, UT", city: "Provo", state: "Utah" },
  {
    regionId: "395053",
    name: "Salt Lake City, UT",
    city: "Salt Lake City",
    state: "Utah",
  },
  {
    regionId: "395022",
    name: "Richmond, VA",
    city: "Richmond",
    state: "Virginia",
  },
  {
    regionId: "394816",
    name: "Madison, WI",
    city: "Madison",
    state: "Wisconsin",
  },
  {
    regionId: "394862",
    name: "Milwaukee, WI",
    city: "Milwaukee",
    state: "Wisconsin",
  },
  { regionId: "102001", name: "United States", city: "null", state: "" },
];
